import { render, staticRenderFns } from "./VerificationIdentityChecklistItem.vue?vue&type=template&id=95535cde&scoped=true"
import script from "./VerificationIdentityChecklistItem.vue?vue&type=script&lang=js"
export * from "./VerificationIdentityChecklistItem.vue?vue&type=script&lang=js"
import style0 from "./VerificationIdentityChecklistItem.vue?vue&type=style&index=0&id=95535cde&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95535cde",
  null
  
)

export default component.exports